import React, { useState } from 'react';
import Data from '../../Data/Data.json'
import { Button, Table, Typography, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Backspace, Print } from '@mui/icons-material';
import { Box, Button as ButtonI } from '@mui/material';
import IosShareIcon from '@mui/icons-material/IosShare';
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { AggregateDescriptor, GroupDescriptor } from "@progress/kendo-data-query";
import { useAuthUser } from '../../Services/Auth/sessionAuth';
import { GridPDFExport, } from "@progress/kendo-react-pdf";
import Utilisateur from '../../Models/Utilisateur';
import Logo from "../../Res/csal-logo.svg"
import i18next from 'i18next';
import ExcelIcon from '../../Res/ExcelIcon.svg';
import PageNotFound from '../../Pages/PageNotFound';
import formatNumber from '../../Functions/Traitement/FormatNumber';
import DataHistoCpt from '../../Types/DataHistoCpt';
import ReformatNumber from '../../Functions/Traitement/ReformatNumber';

const PrintShemaComptable = () => {
    const [tab, setTab] = React.useState(localStorage.getItem(Data.LocalVariable.SheComptable) ? JSON.parse(localStorage.getItem(Data.LocalVariable.SheComptable) + "") : null as any)
    const navigate = useNavigate();
    const [DataExcel, SetDataExcel] = useState<DataHistoCpt[]>([]);
    // USER SESSION
    const auth = useAuthUser();
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()));

    //loading Boutton  
    const [loading, setLoading] = useState(false);
    const _exporter = React.createRef<ExcelExport>();


    const CustomGroupFooter = (props: any) => {
        return `Sum: ${props.aggregates.MONTANTDEBIT.sum.toFixed(2)}`;
    };


    const exportExcel = () => {
        SetDataExcel([]);
        tab?.data.map((data: any, indice: any) => {
            DataExcel.push({
                key: indice,
                NOMCPT: data.NOMCPT,
                NUMCPT: data.NUMCPT,
                DATOPE: data.DATOPE,
                TIME: data.TIME,
                DEDEVR: data.DEDEVR,
                REPECE: data.REPECE,
                NUMRAP: data.NUMRAP,
                LIBELL: data.LIBELL,
                MONTANTDEBIT: ReformatNumber(data.MONTANTDEBIT ? data.MONTANTDEBIT : ''),
                MONTANTCREDIT: ReformatNumber(data.MONTANTCREDIT ? data.MONTANTCREDIT : ''),
                SOLDT: ReformatNumber(data.SOLDT),
                NBENEF: data.NBENEF,
                UTISAI: data.UTISAI
            })
        })

        if (!_exporter.current) {
            return;
        }
        setLoading(true);
        _exporter.current.save();
    };

    const handleExport = () => {
        setLoading(false);
    }

    setTimeout(() => {
        if (tab == null) {
            navigate("/SituationClient/"+tab?.form?.NUMCLI)
        }
    }, 2000)

    return (
        <div><br />
            {tab ?
                <>
                    <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
                        <Box className='backBtnt' zIndex={2} onClick={() => {   switch(tab?.P){
                                case "H":{ navigate("/Historique/" + tab?.form?.NUMCPT); break }
                                case "S":{ navigate("/SituationClient/" + tab?.form?.NUMCLI); break }
                             } }}><Backspace /></Box>
                        <ExcelExport data={DataExcel} fileName= {"ShemaComptable"+"_"+user.codage+"_"+user.coduti+"_"+Data.LocalVariable.appName+"_"+Date.now()+".xlsx"}  ref={_exporter} onExportComplete={handleExport}>
                            <ExcelExportColumn field="NUMCPT" title="NUMERO de Compte" locked={true} width={150} />
                            <ExcelExportColumn title="Nom Compte" field="NOMCPT" locked={true} width={150} />
                            <ExcelExportColumn field="DATOPE" title="Date Opération" />
                            <ExcelExportColumn field="DEDEVR" title="Date De Valeur" />
                            <ExcelExportColumn title="Reference" field="NUMRAP" />
                            <ExcelExportColumn field="LIBELL" title="Libelle" />
                            <ExcelExportColumn title="Debit" field="MONTANTDEBIT" groupFooter={CustomGroupFooter} footerCellOptions={{ wrap: true, textAlign: "center" }} width={150} />
                            <ExcelExportColumn title="Crédit" field="MONTANTCREDIT" width={150} groupFooterCellOptions={{ textAlign: "right" }} />
                            <ExcelExportColumn title="Beneficiare" field="NBENEF" />
                        </ExcelExport>


                        <Box marginLeft={'1%'} className={"preview_print"}>
                            <Box className={"title"} display={"flex"} fontStyle={"inherit"}>
                                <img className='printLogo' src={Logo} width={80} />
                                <Typography style={{ textAlign: 'center', marginLeft: '30%' }} className='textTitle'><b>LOT D'ECRITURES COMPTABLES N°</b> : <b>{tab?.SchemaInfo?.reference ? tab?.SchemaInfo?.reference : ""}</b></Typography >
                                <hr className='hide' />
                                <Box display={'flex'} gap={'2em'}  marginLeft={'20%'} >
                                    <Button title='Imprimer ( ctrl + p )' onClick={() => { window.print() }} icon={<Print />} size='large' className='bt_add' type="ghost" htmlType="button" block  ></Button>
                                    <img  onClick={exportExcel} style={{ width: 35 }} src={ExcelIcon}></img>  
                                </Box>
                            </Box><br />
                            <Box display={"flex"} fontStyle="inherit">
                                <Box width={"40%"} >
                                    {/* <Box width={"120%"} display={"flex"}><Typography>Agence : </Typography><Typography style={{ marginLeft: '2%' }} ><b>{user.codage}</b> {user.agence}</Typography></Box>
                                   */}
                                    <hr />
                                </Box>
                                <Box width={"30%"} marginTop={'-1%'}>
                                    <Typography style={{ textAlign: 'center' }} > <b>{"Date D'Opération " + tab?.SchemaInfo?.DateOpe}</b> </Typography>
                                </Box>
                                <Box style={{ marginLeft: '5%' }} width={"50%"}>
                                    <Box className='haut' width={"120%"} display={"flex"}><Typography >{"Imprimé par " + user.codage + " - " + user.nomuti + " le " + (new Date(Date.now())).toLocaleDateString(i18next.language) + " à " + (new Date(Date.now())).toLocaleTimeString(i18next.language)}</Typography></Box>
                                    {/* <Box width={"120%"} display={"flex"}><Typography>Blocage :</Typography> <Typography className='textRight'><b>{tab?.form?.BLOQUE + " "} {tab.form.CDDEVS ? tab.form.CDDEVS : ""}  </b></Typography></Box>
                                    <Box width={"120%"} display={"flex"}><Typography>Autorisation/facilté :</Typography> <Typography className='textRight'><b>{tab?.form?.AUTORI + " "} {tab.form.CDDEVS ? tab.form.CDDEVS : ""}  </b></Typography></Box> */}
                                </Box>
                            </Box>
                            <Table size='small' showHeader bordered={true} columns={tab?.columns} dataSource={tab.data} />
                            <Box display={"flex"} sx={{ marginLeft: '5%' }} gap={'40%'} >
                                <Typography > <b>Total  / Nombre Débit  : </b> <b>{formatNumber(tab?.SchemaInfo?.TotalDebit) + " "} {tab.form.CDDEVS ? tab.form.CDDEVS : " "}  </b> /  {tab?.SchemaInfo?.Nbrdebit}  </Typography>
                                <Typography > <b>Total  / Nombre Crédit : </b> <b>{formatNumber(tab?.SchemaInfo?.TotalDebit) + " "} {tab.form.CDDEVS ? tab.form.CDDEVS : " "}</b> /  {tab?.SchemaInfo?.NbrCrebit} </Typography>
                            </Box  >

                        </Box>
                    </Spin>
                </>
                :
                <PageNotFound message={"Nothing to print"} backLink={"/"} texttButton={"Back to Loan Simulator"} />}
        </div >
    );
};

export default PrintShemaComptable;